import { MemoizedSelector } from '@ngrx/store';
import { AddNamedSelector } from './helpers';

export function SetSelector<T>(selectorName: string, selector: MemoizedSelector<any, T>) {
  return function(target: any, propertyKey: string) {
    AddNamedSelector(target, propertyKey, selectorName, selector);
  }
}
